import styled from "styled-components"

const TextInputBorder = styled.div<{ readonly error: boolean }>`
    position: absolute;
    top: -4px;
    left: -4px;
    width: calc(100% + 8px);
    height: calc(100% + 8px);

    background-color: ${props => props.error ? 'rgba(245, 99, 99, .3)' : '#fff'};
    border: ${props => props.error ? '5px solid rgba(255, 255, 255, 0)' : '5px solid rgba(255, 255, 255, 1)'};
    border-radius: 6px;

    transition: border .2s, background-color .2s;
    z-index: 0;
`

export default TextInputBorder